import { Button, ButtonProps, styled, Theme } from "@mui/material";
import { IStyledButtonProps } from "./types";

const pickColor = (theme: Theme, variant: ButtonProps["variant"]) => {
    const { palette } = theme as any;
    const safeVariant: NonNullable<ButtonProps["variant"]> = variant || "text";

    const variants = {
        primary: {
            contained: {
                backgroundColor: palette.primary.darker,
                color: palette.neutral.lighter,
                "&:hover": {
                    //border: `1px solid ${palette.primary.dark}`,
                    backgroundColor: palette.primary.darkest,
                    color: palette.primary.dark,
                },
            },
            outlined: {
                borderColor: palette.primary.main,
                color: palette.primary.main,
                "&:hover": {
                    // outlined em hover fica como o contained
                    backgroundColor: palette.primary.main,
                    color: palette.neutral.darkest,
                    borderColor: palette.primary.main,
                },
            },
            text: {
                color: palette.primary.main,
                "&:hover": {
                    // text fica mais escuro no hover
                    color: palette.primary.dark,
                },
            },
        },
        secondary: {
            contained: {
                backgroundColor: palette.secondary.main,
                color: palette.neutral.darkest,
                "&:hover": {
                    backgroundColor: palette.secondary.light,
                    color: palette.neutral.darkest,
                },
            },
            outlined: {
                borderColor: palette.secondary.main,
                color: palette.secondary.main,
                "&:hover": {
                    backgroundColor: palette.secondary.main,
                    color: palette.neutral.darkest,
                    borderColor: palette.secondary.main,
                },
            },
            text: {
                color: palette.secondary.main,
                "&:hover": {
                    // usa um tom um pouco mais "escuro" (mais intenso)
                    color: palette.secondary.light,
                },
            },
        },
        neutral: {
            contained: {
                backgroundColor: palette.neutral.main,
                color: palette.neutral.darkest,
                "&:hover": {
                    backgroundColor: palette.neutral.light,
                    color: palette.neutral.darkest,
                },
            },
            outlined: {
                borderColor: palette.neutral.main,
                color: palette.neutral.main,
                "&:hover": {
                    backgroundColor: palette.neutral.main,
                    color: `${palette.neutral.darkest} !important`,
                    borderColor: palette.neutral.main,
                    "& .MuiTypography-root":{
                        color: `${palette.neutral.darkest} !important`,
                    },
                    "& .MuiSvgIcon-root":{
                        color: `${palette.neutral.darkest} !important`
                    }
                },
            },
            text: {
                color: palette.neutral.main,
                "&:hover": {
                    color: palette.neutral.dark,
                },
            },
        },
    } as const;

    return {
        primary: variants.primary[safeVariant],
        secondary: variants.secondary[safeVariant],
        neutral: variants.neutral[safeVariant],
    };
};

const StyledButton = styled(Button, {
    shouldForwardProp: prop => !['customVariant', 'customColor'].includes(prop.toString())
})<IStyledButtonProps>(
    ({ theme, customColor, variant }) => {
        const colorMap = pickColor(theme, variant);
        const colorStyles = (colorMap[customColor] || {}) as any;

        return {
            boxSizing: "border-box",
            textTransform: "none",
            ...colorStyles,
        };
    }
);

export { StyledButton }